import { buildSlice, CommonState } from '~libs/reduxUtils';

import { SahServiceTypeAssociation } from '~lookups/models';

import { sahServiceTypeAssociationsApi, typePrefix } from '~support-at-home/actions/sahServiceTypeAssociations';

interface SahServiceTypeAssociationsState extends CommonState<SahServiceTypeAssociation> {
  total: number;
}

const initialState: SahServiceTypeAssociationsState = {
  loading: 'idle',
  error: null,
  rows: [],
  total: 0,
};

const slice = buildSlice<SahServiceTypeAssociationsState, SahServiceTypeAssociation>(typePrefix, initialState, {
  rtkQueryBridges: [
    {
      endpoint: sahServiceTypeAssociationsApi.endpoints.getAssocs,
      mode: 'list',
      apply: (state, payload) => {
        const { rows, total } = payload;
        state.rows = rows as SahServiceTypeAssociation[];
        state.total = total;
      },
    },
  ],
});

export const { clear } = slice.actions;
export default slice.reducer;
